const $ = window.jQuery;
const $window = window.$window || $(window);
import '../../../assets/js/vendors/jquery.nav'
import Sticky from 'sticky-js'

const modules = {
    init() {
        console.log('product')
        var sticky = new Sticky('.sticky')
        sticky.update()

        $('.product-nav-list').onePageNav({
            changeHash: true
        })
    },
};

export default modules;
